import type { DashboardSalesPrimaryData } from "./domain";

export const dashboardOrderStages: Record<string, string> = {
  new: "Новый", confirmed: "Подтверждён", reserved: "Зарезервирован",
  assigned: "Назначен", picking: "Комплектация", ready: "Готов к продаже",
  received: "Принят аптекой", fulfilled: "Исполнен", closed: "Закрыт", cancelled: "Отменён",
};

export function dashboardPeriodError(from: string, to: string): string {
  const valid = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value)
    && !Number.isNaN(Date.parse(`${value}T00:00:00Z`))
    && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
  if (!valid(from) || !valid(to)) return "Укажите обе даты периода";
  if (from > to) return "Начало периода должно быть не позже окончания";
  if ((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000 > 366) {
    return "Выберите период не длиннее 367 дней";
  }
  return "";
}

export function fiscalPrimaryHref(value: Pick<DashboardSalesPrimaryData, "kind" | "id">): string | null {
  if (value.kind === "fiscal_sale") {
    return `#/retail?${new URLSearchParams({ view: "sales", realSaleId: value.id })}`;
  }
  if (value.kind === "fiscal_return") {
    return `#/retail?${new URLSearchParams({ view: "returns", realReturnId: value.id })}`;
  }
  return null;
}
